module.exports = __webpack_public_path__ + "static/img/97-2.d458d9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/97-2.jpg
// module id = HnMP
// module chunks = 0